<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <span v-if="$route.params.id">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/segment/listesi">{{ $t('menu.vehicleSegments') }}</router-link> / {{ item.name_readable }}
        </span>
        <span v-else>
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/segment/listesi">{{ $t('menu.vehicleSegments') }}</router-link> / {{ $t('tables.actions.create') }}
        </span>
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <input type="hidden" v-model="form.language"/>
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <va-input
            v-model="form.name"
            label="İsim"
            placeholder="Segment ismi girin"
            required
          />
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import vehicleSegmentServices from '../../../services/api/vehicleSegment'
import responseMixin from '../../../services/api/response'
export default {
  mixins: [responseMixin],
  data () {
    return {
      item: {},
      form: {
        language: 'tr',
        name: ''
      },
    }
  },
  watch: {
    '$route': function(val) {
      this.item = {};
      this.form = {language: 'tr', name: ''};
      if(val.params.id) {
        this.getVehicleSegment(val.params.id);
      }
    }
  },
  methods: {
    async getVehicleSegment(id){
      const result = await vehicleSegmentServices.get(id);
      if(result.error){
        return ;
      }
      this.item = result.data.data;
      this.form.language = 'tr';
      this.form.name = this.item.name.tr;
    },
    async postVehicleSegment() {
      const res = await vehicleSegmentServices.post({
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('POST', 'error', res);
        return ;
      }
      this.responseToast('POST', 'success');
      this.redirectTo('/segment/listesi', 2500);
    },
    async putVehicleSegment(id) {
      const res = await vehicleSegmentServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    onsubmit () {
      //validation
      if(this.$route.params.id) {
        this.putVehicleSegment(this.$route.params.id);
      }
      else {
        this.postVehicleSegment();
      }
    },
  },
  created () {
    if(this.$route.params.id) {
      this.getVehicleSegment(this.$route.params.id);
    }
  },
}
</script>